export interface ProfileToneDto
{
    getMsisdn(): string;
    getDays(): string;
    getLanguage(): string;
    getToneId(): string;
    getToneName(): string;
    getPackName():string;
    getChannel(): string;
    getUserName(): string;
    getHours():string;
    getMinute():string;

    getStartDate():string;
    getEndDate():string;
    getStartTime():string;
    getEndTime():string;
}

export class ProfileToneDtoImpl implements ProfileToneDto
{
    private msisdn: string;
    private days: string;
    private language: string;
    private toneId: string;
    private toneName: string;
    private packName:string;
    private channel: string = "";
    private userName: string;
    private hours :string;
    private minute:string;

    private startDate: string = "";
    private endDate: string;
    private startTime :string;
    private endTime:string;

    getUserName(): string {
       return this.userName;
    }

    setUserName(userName: string)
    {
        this.userName = userName;
    }
    setChannel(channel: string)
    {
        this.channel = channel;
    }

    getChannel(): string {
       return this.channel;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getToneId(): string 
    {
        return this.toneId;
    }
    setToneId(toneId: string)
    {
        this.toneId = toneId;
    }

    getToneName(): string 
    {
        return this.toneName;
    }
    setToneName(toneName: string)
    {
        this.toneName = toneName;
    }

    getPackName():string
    {
        return this.packName;
    }

    setPackName(packName:string):void
    {
        this.packName = packName;
    }

    getHours():string
    {
        return this.hours;
    }

    setHours(hours:string):void{

         this.hours = hours;
    }
       
    getMinute():string{

        return this.minute;
    }

    setMinute(minute:string):void{

        this.minute = minute;
    }

    getDays():string{
         return this.days;
    }

    setDays(days:string):void
    {
        this.days = days;
    }
    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getStartDate():string{

        return this.startDate;
    }

    setStartDate(startDate:string):void{

        this.startDate = startDate;
    }

    getEndDate():string{

        return this.endDate;
    }

    setEndDate(endDate:string):void{

        this.endDate = endDate;
    }

    getStartTime():string{

        return this.startTime;
    }

    setStartTime(startTime:string):void{

        this.startTime = startTime;
    }

    getEndTime():string{

        return this.endTime;
    }

    setEndTime(endTime:string):void{

        this.endTime = endTime;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/profiletune/profiletonedto.ts